import styled from "styled-components"
import React, { ReactNode, useLayoutEffect, useRef, useState } from "react"
import { theme } from "../../../../theme"

export type StickyScrollbarProps = {
  children?: ReactNode
  className?: string
}

export const StickyScrollbar = (props: StickyScrollbarProps) => {
  const { children, className } = props

  const outerRef = useRef<HTMLDivElement>(null)
  const childRef = useRef<HTMLDivElement>(null)
  const [width, setWidth] = useState("auto")
  const [outerWidth, setOuterWidth] = useState("auto")

  const calculateOuterWidth = () => {
    let newWidth = "auto"

    if (childRef.current?.offsetWidth) {
      newWidth = childRef.current?.offsetWidth + "px"
    }

    if (newWidth !== width) {
      setOuterWidth(newWidth)
    }
  }

  const calculateWidth = () => {
    let newWidth = "auto"

    if (childRef.current?.scrollWidth) {
      newWidth = childRef.current?.scrollWidth + "px"
    }

    if (newWidth !== width) {
      setWidth(newWidth)
    }
  }

  const resize = () => {
    calculateOuterWidth()
    calculateWidth()
  }

  useLayoutEffect(() => {
    if (outerRef.current) {
      outerRef.current.onscroll = () => {
        if (childRef.current && outerRef.current) {
          childRef.current.scrollLeft = outerRef.current.scrollLeft
        }
      }
    }
  }, [outerRef.current])

  useLayoutEffect(() => {
    if (childRef.current) {
      childRef.current.onscroll = () => {
        if (childRef.current && outerRef.current) {
          outerRef.current.scrollLeft = childRef.current.scrollLeft
        }
      }
    }
  }, [childRef.current])

  useLayoutEffect(() => {
    resize()
  }, [children])

  useLayoutEffect(() => {
    window.addEventListener("resize", resize)
    return () => {
      window.removeEventListener("resize", resize)
    }
  }, [])

  return (
    <div className={className}>
      <OuterContainer
        ref={outerRef}
        style={{
          width: outerWidth,
        }}
      >
        <div
          style={{
            width,
          }}
        >
          &nbsp;
        </div>
      </OuterContainer>
      <ChildContainer ref={childRef}>{children}</ChildContainer>
    </div>
  )
}

const OuterContainer = styled.div`
  overflow-x: auto;
  overflow-y: hidden;
  position: fixed;
  bottom: 0;
  z-index: ${theme.zIndex.high};
`

const ChildContainer = styled.div`
  overflow: auto;
  overflow-y: hidden;
  -ms-overflow-style: none; /* Internet Explorer 10+ */
  scrollbar-width: none; /* Firefox */

  &::-webkit-scrollbar {
    display: none; /* Safari and Chrome */
  }
`
